import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FieldConfig} from "../../../interfaces/field.interface";
import {DynamicFieldDirective} from "../dynamic-field/dynamic-field.directive";
import {interval} from "rxjs";
import {debounce} from "rxjs/operators";

/**
 * https://medium.com/@mail.bahurudeen/create-a-dynamic-form-with-configurable-fields-and-validations-using-angular-6-994db56834da
 * https://github.com/bahurudeen/dynamicform
 */
@Component({
    exportAs: "dynamicForm",
    selector: "dynamic-form",
    template: `
        <form class="dynamic-form" [formGroup]="form">
          @for (field of fields; track field) {
            <ng-container dynamicField [field]="field" [group]="form">
            </ng-container>
          }
        </form>
        `,
    styles: []
})
export class DynamicFormComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChildren(DynamicFieldDirective) viewChildren: QueryList<DynamicFieldDirective>;
    @Input() fields: FieldConfig[] = [];
    @Input() ignoreValidation = false;
    @Input() debounceTime = 300;

    /* tslint:disable */
    @Output() submit: EventEmitter<any> = new EventEmitter<any>();

    private subscriber;
    form: FormGroup;

    get value() {
        return this.form.value;
    }

    constructor(private fb: FormBuilder) {
    }

    /**
     get fields of DynamicFieldDirective so we can work with the dynamic fields directly
     **/
    public getFields(): QueryList<DynamicFieldDirective> {
        return this.viewChildren;
    }

    ngOnInit() {
        this.form = this.createControl();
        // this.form.enable({ emitEvent: false });
    }

    ngAfterViewInit() {
        this.subscriber = this.form.valueChanges
            // .debounce(ev => someEvent.value ? Observable.empty() : interval(25))
            .pipe(debounce((e) => interval(this.debounceTime)))
            .subscribe(val => {
                // if (!this.form.valid && Lib.DevShow`Dynamic component controlling ${this.fields}`);
                this.onSubmit(null);
            });
    }

    public values(i_values, i_type = null) {
        if (i_type === 'color') {
            // ** set emit event false, because when label is edited, cursor is moved to forward
            // ** but, need to check more if this changes break existing feature or not.
            this.form.patchValue(i_values, {emitEvent: false});
        } else {
            this.form.patchValue(i_values, {emitEvent: false});
        }
    }

    public disableForm(i_value) {
        if (i_value) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }

    public isTouchedForm() {
        return this.form.touched;
    }

    onSubmit(event: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        // if (!this.form.valid && Lib.DevShow('Sean not submitting form as not valid...');
        if (this.form.valid || this.ignoreValidation === true) {
            this.submit.emit(this.form.value);
        } else {
            this.validateAllFormFields(this.form);
        }
    }

    createControl() {
        const group = this.fb.group({});
        this.fields.forEach(field => {
            if (field.type === "button") return;
            const control = this.fb.control(
                field.value,
                this.bindValidations(field.validations || [])
            );
            if (field.disabled) control.disable();
            group.addControl(field.name, control);
        });
        return group;
    }

    bindValidations(validations: any) {
        if (validations.length > 0) {
            const validList = [];
            validations.forEach(valid => {
                validList.push(valid.validator);
            });
            return Validators.compose(validList);
        }
        return null;
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            control.markAsTouched({onlySelf: true});
        });
    }

    ngOnDestroy() {
        this.subscriber.unsubscribe();
    }
}
